<template>
  <section class="section__monster">
    <!-- All animating objects -->
    <div class="section__monster--bg">
      <div class="section__monster--clouds" data-aos="fade-up">
        <img
          id="cloud_1"
          class="small cloud lazyload"
          src="https://ik.imagekit.io/intervi/tr:bl-7/cloud_B1UGGWea4.png"
          data-src="https://ik.imagekit.io/intervi/cloud_B1UGGWea4.png"
          alt="Cloud"
        />
        <img
          id="cloud_2"
          class="big cloud lazyload"
          src="https://ik.imagekit.io/intervi/tr:bl-7/cloud_B1UGGWea4.png"
          data-src="https://ik.imagekit.io/intervi/cloud_B1UGGWea4.png"
          alt="Cloud"
        />
        <img
          id="cloud_3"
          class="medium cloud lazyload"
          src="https://ik.imagekit.io/intervi/tr:bl-7/cloud_B1UGGWea4.png"
          data-src="https://ik.imagekit.io/intervi/cloud_B1UGGWea4.png"
          alt="Cloud"
        />
        <img
          id="cloud_4"
          class="big cloud lazyload"
          src="https://ik.imagekit.io/intervi/tr:bl-7/cloud_B1UGGWea4.png"
          data-src="https://ik.imagekit.io/intervi/cloud_B1UGGWea4.png"
          alt="Cloud"
        />
        <img
          id="cloud_5"
          class="small cloud lazyload"
          src="https://ik.imagekit.io/intervi/tr:bl-7/cloud_B1UGGWea4.png"
          data-src="https://ik.imagekit.io/intervi/cloud_B1UGGWea4.png"
          alt="Cloud"
        />
        <img
          id="cloud_6"
          class="small cloud lazyload"
          src="https://ik.imagekit.io/intervi/tr:bl-7/cloud_B1UGGWea4.png"
          data-src="https://ik.imagekit.io/intervi/cloud_B1UGGWea4.png"
          alt="Cloud"
        />

        <div class="monsters__box">
          <img
            id="monsters"
            data-src="https://ik.imagekit.io/intervi/monsters_rkeRUWA7P4.png"
            class="lazyload"
            alt="Monsters"
          />
        </div>

        <img
          id="trees"
          class="three lazyload"
          src="https://ik.imagekit.io/intervi/tr:bl-7/trees_HkHb7Zep4.png"
          data-src="https://ik.imagekit.io/intervi/trees_HkHb7Zep4.png"
          alt="Trees"
        />
        <img
          id="cloud_7"
          class="cloud big lazyload"
          src="https://ik.imagekit.io/intervi/tr:bl-7/cloud_B1UGGWea4.png"
          data-src="https://ik.imagekit.io/intervi/cloud_B1UGGWea4.png"
          alt="Cloud"
        />
        <img
          id="cloud_8"
          class="cloud medium lazyload"
          src="https://ik.imagekit.io/intervi/tr:bl-7/cloud_B1UGGWea4.png"
          data-src="https://ik.imagekit.io/intervi/cloud_B1UGGWea4.png"
          alt="Cloud"
        />
        <img
          id="cloud_9"
          class="cloud big lazyload"
          src="https://ik.imagekit.io/intervi/tr:bl-7/cloud_B1UGGWea4.png"
          data-src="https://ik.imagekit.io/intervi/cloud_B1UGGWea4.png"
          alt="Cloud"
        />
      </div>
    </div>
  </section>
</template>

<script>
// Import small components
import SectionTitle from "@/components/small-components/SectionTitle";
import MainSectionFooter from "@/components/small-components/MainSectionFooter";
import FloatingSocials from "@/components/small-components/FloatingSocials";
import FloatingCaseStudy from "@/components/small-components/FloatingCaseStudy";
import MobileDetect from "mobile-detect";

export default {
  name: "ComponentSocialMonster",
  data() {
    return {
      thisSection: 1,
      isMobile: false
    };
  },
  props: ["showChild", "activeSection"],
  mounted: function() {
    this.detectionMobile();
    this.mouseMonsters();
    // this.mouseClouds();
    this.mouseThrees();
    this.cloud1();
    this.cloud2();
    this.cloud3();
    this.cloud4();
    this.cloud5();
    this.cloud6();
    this.cloud7();
    this.cloud8();
    this.cloud9();
  },
  updated: function() {},
  methods: {
    detectionMobile: function() {
      var md = new MobileDetect(window.navigator.userAgent);
      var _this = this;
      if (
        md.mobile() !== null ||
        md.mobile() == "UnknownPhone" ||
        md.mobile() == "GenericPhone" ||
        md.mobile() == "iPhone" ||
        md.mobile() == "iPad" ||
        md.mobile() == "Tablet" ||
        md.mobile() == "Kindle" ||
        md.mobile() == "HTC" ||
        md.mobile() == "Samsung" ||
        md.mobile() == "BlackBerry" ||
        md.mobile() == "LG" ||
        md.mobile() == "NokiaLumia" ||
        md.mobile() == "NexusTablet" ||
        md.mobile() == "Xiaomi" ||
        md.mobile() == "Huawei"
      ) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    mouseMonsters: function() {
      $(document).mousemove(function(event) {
        $("#monsters").each(function(index, element) {
          var xPos = event.clientX / $(window).width() - 0.5,
            yPos = event.clientY / $(window).height() - 0.5,
            box = element;

          TweenLite.to(box, 1, {
            x: xPos * -20 * Math.random() + 5,
            ease: Power1.easeOut
          });
        });
      });
    },

    mouseClouds: function() {
      $(document).mousemove(function(event) {
        $(".cloud").each(function(index, element) {
          var xPos = event.clientX / $(window).width() - 0.5,
            yPos = event.clientY / $(window).height() - 0.5,
            box = element;

          TweenLite.to(box, 1, {
            x: xPos * 40 * Math.random() + 10,
            ease: Power1.easeOut
          });
        });
      });
    },
    mouseThrees: function() {
      $(document).mousemove(function(event) {
        $(".three").each(function(index, element) {
          var xPos = event.clientX / $(window).width() - 0.5,
            yPos = event.clientY / $(window).height() - 0.5,
            box = element;

          TweenLite.to(box, 1, {
            x: xPos * 40 * Math.random() + 5,
            ease: Power1.easeOut
          });
        });
      });
    },

    // enter/leave animations
    // monsters
    // enterMonsters: function(el, done) {
    //   TweenMax.fromTo(
    //     el,
    //     1,
    //     { opacity: "0" },
    //     {
    //       opacity: "1",
    //       ease: Power1.easeInOut,
    //       delay: 0.5
    //     }
    //   );
    // },
    // leaveMonsters: function(el, done) {
    //   TweenMax.to(el, 1, { opacity: "0", ease: Power1.easeInOut });
    // },

    // trees
    // enterTrees: function(el, done) {
    //   TweenMax.fromTo(
    //     el,
    //     1,
    //     { y: "100%" },
    //     {
    //       y: "0%",
    //       ease: Power1.easeInOut,
    //       delay: 0.4
    //     }
    //   );
    // },
    // leaveTrees: function(el, done) {
    //   TweenMax.to(el, 1, { y: "100%", ease: Power1.easeInOut, delay: 0.2 });
    // },
    // cloud 1
    enterCloud1: function(el, done) {
      TweenMax.fromTo(
        el,
        1,
        { top: "100%" },
        {
          top: "10%",
          ease: Power1.easeInOut,
          delay: 0.1
        }
      );
    },
    leaveCloud1: function(el, done) {
      TweenMax.to(el, 1, { top: "100%", ease: Power1.easeInOut, delay: 0.2 });
    },
    // cloud 2
    enterCloud2: function(el, done) {
      TweenMax.fromTo(
        el,
        1,
        { top: "100%" },
        {
          top: "70%",
          ease: Power1.easeInOut,
          delay: 0.2
        }
      );
    },
    leaveCloud2: function(el, done) {
      TweenMax.to(el, 1, { top: "100%", ease: Power1.easeInOut, delay: 0.2 });
    },
    // cloud 3
    enterCloud3: function(el, done) {
      TweenMax.fromTo(
        el,
        1,
        { top: "100%" },
        {
          top: "35%",
          ease: Power1.easeInOut,
          delay: 0.2
        }
      );
    },
    leaveCloud3: function(el, done) {
      TweenMax.to(el, 1, { top: "100%", ease: Power1.easeInOut, delay: 0.2 });
    },
    // cloud 4
    enterCloud4: function(el, done) {
      TweenMax.fromTo(
        el,
        1,
        { top: "100%" },
        {
          top: "60%",
          ease: Power1.easeInOut,
          delay: 0.2
        }
      );
    },
    leaveCloud4: function(el, done) {
      TweenMax.to(el, 1, { top: "100%", ease: Power1.easeInOut, delay: 0.2 });
    },
    // cloud 5
    enterCloud5: function(el, done) {
      TweenMax.fromTo(
        el,
        1,
        { top: "100%" },
        {
          top: "15%",
          ease: Power1.easeInOut,
          delay: 0.2
        }
      );
    },
    leaveCloud5: function(el, done) {
      TweenMax.to(el, 1, { top: "100%", ease: Power1.easeInOut, delay: 0.2 });
    },
    // cloud 6
    enterCloud6: function(el, done) {
      TweenMax.fromTo(
        el,
        1,
        { top: "100%" },
        {
          top: "33%",
          ease: Power1.easeInOut,
          delay: 0.2
        }
      );
    },
    leaveCloud6: function(el, done) {
      TweenMax.to(el, 1, { top: "100%", ease: Power1.easeInOut, delay: 0.2 });
    },
    // cloud 7
    enterCloud7: function(el, done) {
      TweenMax.fromTo(
        el,
        1,
        { top: "100%" },
        {
          top: "20%",
          ease: Power1.easeInOut,
          delay: 0.2
        }
      );
    },
    leaveCloud7: function(el, done) {
      TweenMax.to(el, 1, { top: "100%", ease: Power1.easeInOut, delay: 0.2 });
    },
    // cloud 8
    enterCloud8: function(el, done) {
      TweenMax.fromTo(
        el,
        1,
        { top: "100%" },
        {
          top: "40%",
          ease: Power1.easeInOut,
          delay: 0.2
        }
      );
    },
    leaveCloud8: function(el, done) {
      TweenMax.to(el, 1, { top: "100%", ease: Power1.easeInOut, delay: 0.2 });
    },
    // cloud 9
    enterCloud9: function(el, done) {
      TweenMax.fromTo(
        el,
        1,
        { top: "100%" },
        {
          top: "60%",
          ease: Power1.easeInOut,
          delay: 0.2
        }
      );
    },
    leaveCloud9: function(el, done) {
      TweenMax.to(el, 1, { top: "100%", ease: Power1.easeInOut, delay: 0.2 });
    },

    // loop animations
    monsters: function(el, done) {
      TweenMax.fromTo(
        "#monsters",
        30,
        { x: "0px" },
        { x: "-250px", delay: 0.7, yoyo: true, repeat: -1 }
      );
    },
    trees: function(el, done) {
      TweenMax.fromTo(
        "#trees",
        30,
        { x: "0px" },
        {
          x: "-100px",
          delay: 0.7,
          yoyo: true,
          ease: Power1.easeInOut,
          repeat: -1
        }
      );
    },
    cloud1: function(el, done) {
      TweenMax.fromTo(
        "#cloud_1",
        45,
        { x: "0px" },
        {
          x: "-300px",
          delay: 0.7,
          yoyo: true,
          //  ease: linear,
          repeat: -1
        }
      );
    },
    cloud2: function(el, done) {
      TweenMax.fromTo(
        "#cloud_2",
        45,
        { x: "0px" },
        {
          x: "-300px",
          delay: 0.7,
          yoyo: true,
          // ease: Power1.easeInOut,
          repeat: -1
        }
      );
    },
    cloud3: function(el, done) {
      TweenMax.fromTo(
        "#cloud_3",
        45,
        { x: "0px" },
        {
          x: "-500px",
          delay: 0.7,
          yoyo: true,
          // ease: Power1.easeInOut,
          repeat: -1
        }
      );
    },
    cloud4: function(el, done) {
      TweenMax.fromTo(
        "#cloud_4",
        45,
        { x: "0px" },
        {
          x: "-300px",
          delay: 0.7,
          yoyo: true,
          // ease: Power1.easeInOut,
          repeat: -1
        }
      );
    },
    cloud5: function(el, done) {
      TweenMax.fromTo(
        "#cloud_5",
        45,
        { x: "0px" },
        {
          x: "-300px",
          delay: 0.7,
          yoyo: true,
          // ease: Power1.easeOut,
          repeat: -1
        }
      );
    },
    cloud6: function(el, done) {
      TweenMax.fromTo(
        "#cloud_6",
        45,
        { x: "0px" },
        {
          x: "-300px",
          delay: 0.7,
          yoyo: true,
          // ease: Power1.easeInOut,
          repeat: -1
        }
      );
    },
    cloud7: function(el, done) {
      TweenMax.fromTo(
        "#cloud_7",
        45,
        { x: "0px" },
        {
          x: "-500px",
          delay: 0.7,
          yoyo: true,
          // ease: Power1.easeInOut,
          repeat: -1
        }
      );
    },
    cloud8: function(el, done) {
      TweenMax.fromTo(
        "#cloud_8",
        45,
        { x: "0px" },
        {
          x: "-500px",
          delay: 0.7,
          yoyo: true,
          // ease: Power1.easeInOut,
          repeat: -1
        }
      );
    },
    cloud9: function(el, done) {
      TweenMax.fromTo(
        "#cloud_9",
        45,
        { x: "0px" },
        {
          x: "-300px",
          delay: 0.7,
          yoyo: true,
          // ease: Power1.easeInOut,
          repeat: -1
        }
      );
    }
  },
  // Init components
  components: {
    SectionTitle: SectionTitle,
    MainSectionFooter: MainSectionFooter,
    FloatingSocials: FloatingSocials,
    FloatingCaseStudy: FloatingCaseStudy
  }
};
</script>



// WEBPACK FOOTER //
// src/components/inner-components/ComponentSocialMonster.vue